"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports.nilUuid = exports.objectFromArray = exports.base64StringToBlob = void 0;
exports.cloneDeep = cloneDeep;
exports.classes = classes;
exports.filter = filter;
exports.formatPhoneNumber = formatPhoneNumber;
exports.capitalize = capitalize;
exports.shuffleArray = shuffleArray;
exports.parseBool = parseBool;
exports.parseBoolSoft = parseBoolSoft;
exports.boolYesNo = boolYesNo;
exports.zeroPad = zeroPad;
exports.sOrNot = sOrNot;
exports.formatMoneyLegacy = formatMoneyLegacy;
exports.formatMoney = formatMoney;
exports.formatNumber = formatNumber;
exports.isEmpty = isEmpty;
exports.cleanBool = cleanBool;
exports.scrubString = scrubString;
exports.cleanString = cleanString;
exports.downloadBlobAsFile = downloadBlobAsFile;
exports.downloadDataUri = downloadDataUri;
exports.cleanNullFromObject = cleanNullFromObject;
exports.encodeQuery = encodeQuery;
exports.ordinal = ordinal;
exports.createList = createList;
exports.timeSince = timeSince;
exports.range = range;
exports.formatAddress = formatAddress;
function cloneDeep(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function classes(...args) {
    return args.filter(Boolean).join(' ');
}
function filter(...args) {
    return args.filter(Boolean).join(' ');
}
function formatPhoneNumber(number) {
    if (!number)
        return number;
    return number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}
// function to capitalize the first letter of each word in a string
function capitalize(str) {
    if (!str)
        return str;
    str = str.replace(/_|-/g, ' ');
    const words = str.split(' ');
    return words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
}
function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}
function parseBool(value) {
    if (typeof value === 'boolean')
        return value;
    if (typeof value === 'string') {
        if (value.toLowerCase() === 'true')
            return true;
        if (value.toLowerCase() === 'false')
            return false;
    }
    throw new Error(`Invalid boolean value: ${value}`);
}
function parseBoolSoft(value) {
    if (typeof value === 'boolean')
        return value;
    if (typeof value !== 'string' || !value)
        return undefined;
    if (value.toLowerCase() === 'true')
        return true;
    if (value.toLowerCase() === 'false')
        return false;
    return undefined;
}
function boolYesNo(value) {
    if (typeof value !== 'boolean')
        return;
    return value ? 'Yes' : 'No';
}
function zeroPad(num, places) {
    return String(num).padStart(places, '0');
}
function sOrNot(count) {
    return count === 1 ? '' : 's';
}
function formatMoneyLegacy(n) {
    if (!n)
        return '$0.00';
    return n.toLocaleString('en-us', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    });
}
function formatMoney(n) {
    if (typeof n === 'string')
        n = parseInt(n);
    if (!n)
        return '$0.00';
    n = n / 100;
    return n.toLocaleString('en-us', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    });
}
function formatNumber(n) {
    if (typeof n === 'string')
        n = parseInt(n);
    if (!n)
        return '0';
    return n.toLocaleString('en-us');
}
function isEmpty(obj) {
    if (obj === null || obj === undefined)
        return true;
    if (typeof obj === 'string' && obj.trim().length === 0)
        return true;
    if (typeof obj === 'object')
        return Object.keys(obj).length === 0;
    return false;
}
function cleanBool(prop) {
    if (!prop)
        return null;
    return prop;
}
function scrubString(prop) {
    if (!prop)
        return null;
    return prop.replace(/[^a-zA-Z0-9]/g, '-');
}
function cleanString(prop) {
    if (!prop)
        return null;
    prop = prop.toLowerCase().replace(/[0-9]/g, '');
    return prop.replace(/[^a-z]/g, '-');
}
function downloadBlobAsFile(blob, filename) {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
}
function downloadDataUri(dataUri, filename) {
    const link = document.createElement('a');
    link.href = dataUri;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
}
const base64StringToBlob = (string) => fetch(string).then(res => res.blob());
exports.base64StringToBlob = base64StringToBlob;
// recursive function to clean null values from an object
function cleanNullFromObject(obj) {
    // console.log(obj);
    if (typeof obj === 'object') {
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                if (obj[key] === null) {
                    delete obj[key];
                }
                else if (typeof obj[key] === 'object') {
                    cleanNullFromObject(obj[key]);
                }
            }
        }
    }
    return obj;
}
function encodeQuery(data) {
    let query = '';
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    for (const d in data)
        query += encodeURIComponent(d) + '=' + encodeURIComponent(data[d]) + '&';
    return query.slice(0, -1);
}
function ordinal(n) {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
function createList(arr) {
    if (arr.length === 0)
        return '';
    if (arr.length === 1)
        return arr[0];
    if (arr.length === 2)
        return arr.join(' and ');
    const last = arr.pop();
    return arr.join(', ') + ', and ' + last;
}
// function that shows the time since a date in the largest unit possible
function timeSince(date) {
    const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
    let interval = Math.floor(seconds / 31536000);
    if (interval > 1)
        return interval + ' years';
    interval = Math.floor(seconds / 2592000);
    if (interval > 1)
        return interval + ' months';
    interval = Math.floor(seconds / 86400);
    if (interval > 1)
        return interval + ' days';
    interval = Math.floor(seconds / 3600);
    if (interval > 1)
        return interval + ' hours';
    interval = Math.floor(seconds / 60);
    if (interval > 1)
        return interval + ' minutes';
    return Math.floor(seconds) + ' seconds';
}
function range(n) {
    return [...Array(n).keys()].map(i => i + 1);
}
const objectFromArray = (array, key) => Object.fromEntries(array.map(a => [a[key], a]));
exports.objectFromArray = objectFromArray;
exports.nilUuid = '00000000-0000-0000-0000-000000000000';
function formatAddress(address, breakLines = false) {
    if (!address)
        return '';
    if (breakLines) {
        return `${address.street}${address.street2 ? `\n${address.street2}` : ''}\n${address.city}, ${address.state} ${address.zip}`;
    }
    return `${address.street}${address.street2 ? ` ${address.street2}` : ''} ${address.city}, ${address.state} ${address.zip}`;
}
const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
exports.sleep = sleep;
